import React, { useEffect } from "react";
import Vision from "./Vision/Vision";
import { Divider } from "antd";
import Hearing from "./Hearing/Hearing";
import Speech from "./Speech/Speech";
import Ambulation from "../Examination/FunctionalExaminationForm/Ambulation";
import DailyActivities from "./DailyActivities/DailyActivities";
import BladderNeeds from "./BladderNeeds/BladderNeeds";
import BowelNeeds from "./BowelNeeds/BowelNeeds";
import Braden from "./Braden/Braden";
import RiskOfFall from "./RiskOfFall/RiskOfFall";
import { NurseInitialContext } from "../HistoryForm/NurseInitialAssessmentFormProvider";

const NurseFunctionalAssessment = ({ form, formData }) => {
  useEffect(() => {
    form.setFieldsValue(formData?.functional_status);
  }, [formData]);
  return (
    <>
      <Vision context={NurseInitialContext} form={form} />
      <Divider />
      <Hearing context={NurseInitialContext} form={form} />
      <Divider />
      <Speech context={NurseInitialContext} form={form} />
      <Divider />
      <Ambulation context={NurseInitialContext} form={form} />
      <Divider />
      <DailyActivities context={NurseInitialContext} form={form} />
      <Divider />
      <BladderNeeds form={form} />
      <Divider />
      <BowelNeeds form={form} />
      <Divider />
      <Braden context={NurseInitialContext} form={form} />
      <Divider />
      <RiskOfFall context={NurseInitialContext} form={form} />
    </>
  );
};

export default NurseFunctionalAssessment;
